export default __webpack_public_path__ + "static/media/folder_ico.3104f637.svg";